import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import routes from "../../routes";
import { attemptUpdateOrder } from "../../store/thunks/order";

import leafy_preview from "../../images/leafy-preview.png";
import dark_preview from "../../images/dark-preview.png";
import floral_preview from "../../images/floral-preview.png";

import TemplatePreview from "../card-templates/TemplatePreview";
import ServerAlert from "../common/ServerAlert";

const templateList = [
  {
    title: "leafy",
    preview: leafy_preview
  },
  {
    title: "dark",
    preview: dark_preview
  },
  {
    title: "floral",
    preview: floral_preview
  }
];

const Template = ({ history }) => {
  const [selection, setSelection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});

  const data = useSelector(({ order }) => order.data);

  const dispatch = useDispatch();

  useEffect(() => {
    if (data.id) {
      if (data.template) {
        setSelection(data.template);
      }
      setInitialLoading(false);
    }
  }, [data]);

  const makeSelection = template => {
    setSelection(template);
  };

  const doSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    await dispatch(
      attemptUpdateOrder({
        ...data,
        template: selection
      })
    )
      .then(() => {
        setLoading(false);
        history.push(routes.guestlist);
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          setErrors({
            ...errors,
            server: error.response.data.message
          });
        }
        setLoading(false);
      });
  };

  const handleBackButton = e => {
    e.preventDefault();
    setSelection(null);
  };

  if (initialLoading) {
    return <div className="dots dots-primary"></div>;
  }

  return (
    <>
      {!selection ? (
        <>
          <h1 className="mb-2">Choose a Design</h1>
          <p className="mb-lg w-75 text-center">
            Pick one of our original designs below to see a full size preview of
            what your custom Save the Date will look like!
          </p>
          <div className="container-fluid">
            <div className="row">
              {templateList.map((template, index) => {
                return (
                  <div
                    key={index}
                    className="col-xs-12 col-md-4 text-center mb-4 mb-md-0"
                  >
                    <img
                      className="img-fluid mb-3"
                      src={template.preview}
                      alt={template.title}
                    />
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => makeSelection(template.title)}
                    >
                      SELECT
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          <h1 className="text-center mb-2">Preview Your Design</h1>
          <p className="mb-lg w-75 text-center">
            Preview your selection, or go back to choose a different design.
          </p>
          <div className="mb-md">
            <TemplatePreview selection={selection} data={data} />
          </div>
          <form noValidate onSubmit={doSubmit} className="mb-3">
            <button
              type="button"
              className="btn btn-secondary text-light mx-2"
              onClick={handleBackButton}
            >
              {!data.template ? <>BACK</> : <>CHANGE</>}
            </button>
            <button
              type="submit"
              className="btn btn-primary mx-2"
              disabled={loading}
            >
              {!loading ? (
                <>NEXT</>
              ) : (
                <div className="dots dots-light mx-auto"></div>
              )}
            </button>
          </form>
          <ServerAlert error={errors["server"]} />
        </>
      )}
    </>
  );
};

export default Template;
